import { User } from '@models/User';

import api from './api';

export async function getUser(username: string) {
  const { data } = await api.get<User>(`users/${username}`);

  return data;
}
